<template>
  <div class="wechat-record">
    <div
      v-if="chatDetailList.length > 0"
      ref="friendChatDetail"
      class="chat-detail-wrap"
      @scroll="handleScroll"
    >
      <!-- 加载更多按钮 (每超过20条才展示)-->
      <div
        v-if="overTotal > 0"
        class="chat-load-msg"
      >
        <span
          class="loading-more-btn"
          @click="loadMoreMsg"
        >点击加载更早的消息</span>
      </div>
      <!-- 聊天内容 -->
      <ul
        ref="chatDetailOul"
        class="chat-detail-oul clearfix"
      >
        <!-- contactId 好友座席id  from值为空代表系统消息 -->
        <template v-for="(list,index) in chatDetailList">
          <!-- 居中（系统消息） -->
          <li
            v-if="list.M7_MsgType === 10000"
            :key="index"
            class="com-chat-detail chat-detail-system fl"
          >
            <p
              v-if="list.M7_Msg.content"
              v-html="list.M7_Msg.content"
            ></p>
            <p
              v-else
              v-html="list.M7_Msg"
            ></p>
          </li>
          <!-- 消息撤回 preContent -->
          <li
            v-else-if="list.M7_Msg && list.M7_MsgType === 10002"
            :key="index"
            class="com-chat-detail chat-detail-system fl"
          >
            <p>
              {{ list.M7_Msg.test || '你撤回了一条消息' }}
              <mk-popover
                size="mini"
                placement="bottom"
                trigger="click"
                :content="list.M7_Msg.preContent || '撤回内容'"
              >
                <mk-button-biz
                  slot="reference"
                  style="padding: 0;"
                  type="text"
                >
                  &nbsp;查看详情
                </mk-button-biz>
              </mk-popover>
            </p>
          </li>
          <!-- 座席 【右侧】 好友【左侧】 -->
          <li
            v-else-if="list.M7_MsgType !== 10000"
            :key="index"
            class="com-chat-detail"
            :class="list.IsSend === '1' ? 'chat-right' : 'chat-left'"
          >
            <!-- 聊天时间 -->
            <p class="com-date">
              {{ list.M7_Ts }}
            </p>

            <div class="com-main-box clearfix">
              <!-- 头像-->
              <img
                v-if="list.IsSend === '1'"
                :src="wxUser.HeadImg ? wxUser.HeadImg : '@assets/images/person.png'"
                alt="error"
                class="fr com-ow-36"
              >
              <img
                v-else
                :src="wxContact.M7HeadImg ? wxContact.M7HeadImg : '@assets/images/person.png'"
                alt="error"
                class="fl com-ow-36"
              >

              <!-- 内容区 -->
              <div
                class="com-content-odv"
                :class="'type-'+list.M7_MsgType"
              >
                <i class="com-icon"></i>
                <!-- 文字 -->
                <template v-if="list.M7_MsgType === 1">
                  <div class="box">
                    <span v-html="list.M7_Msg"></span>
                    <!-- 删除的图标 -->
                  </div>
                </template>

                <!-- 语音 -->
                <template v-else-if="list.M7_MsgType === 34">
                  <div
                    class="box com-voice-odv"
                    @click="playAudio(list.ThumbImgPath)"
                  >
                    <!-- 音量图标 -->
                    <div
                      v-if="list.IsSend === '1'"
                      class="audio-icon audio-icon-left"
                      :class="{'audio-an-right': list.ThumbImgPath === tarUrl}"
                    ></div>
                    <div
                      v-else
                      class="audio-icon audio-icon-right"
                      :class="{'audio-an-left': list.ThumbImgPath === tarUrl}"
                    ></div>
                  </div>
                </template>

                <!-- 图片 -->
                <template v-else-if="list.M7_MsgType === 3">
                  <div class="box com-img-odv emoj-box">
                    <template v-if="!(list.BigImgPath || list.ThumbImgPath)">
                      <mk-iconfont
                        icon-class="wx-duihuatupian"
                        class="iconfont"
                      ></mk-iconfont>
                      <p class="img-none-tip">
                        图片暂未上传，请稍后查看
                      </p>
                    </template>
                    <template v-else>
                      <mk-image
                        class="view-img-box"
                        fit="contain"
                        :lazy="true"
                        :src="'https://' + (list.ThumbImgPath ? list.ThumbImgPath : list.BigImgPath)"
                        :preview-src-list="[('https://'+(list.BigImgPath || list.ThumbImgPath))]"
                        @click="!list.BigImgPath ? $message('设备端未下载，无法查看高清图片') : ''"
                      />
                    </template>
                  </div>
                </template>

                <!-- 视频 -->
                <template v-else-if="list.M7_MsgType === 43">
                  <div
                    class="box emoj-box"
                    @click="showVideoPlay(list.BigImgPath)"
                  >
                    <mk-iconfont
                      icon-class="wx-shipinzhanweifu"
                      class="com-p-a iconfont"
                      style="left: 30px; top: 0; z-index: 99;"
                    ></mk-iconfont>
                    <!-- 缩略图 -->
                    <img
                      :src="'https://' + list.ThumbImgPath"
                      alt=""
                      class="com-p-a"
                      style="top:0; left: 0; width: 100%; height: 100%;"
                    >
                  </div>
                </template>

                <!-- 红包 -->
                <template v-else-if="list.M7_MsgType === 436207665">
                  <div
                    class="box com-red-content-odv"
                    :class="{'get-bg': (list.M7_Msg.wcPayInfo && list.M7_Msg.wcPayInfo.m7Type === '1')}"
                  >
                    <i
                      class="com-icon com-red-icon right-icon"
                      :class="list.status ? 'com-receive-red-icon' : ''"
                    ></i>
                    <!-- 红包内容 -->
                    <div
                      class="com-red-envelope-odv right-red-envelope-odv"
                      :class="list.status ? 'com-receive-red-envelope-odv' : ''"
                    >
                      <!-- 上 -->
                      <div class="com-red-transfer-odv">
                        <i class="com-p-a com-red-oi"></i>
                        <span class="com-p-a com-red-transfer-ospan right-red-transfer-ospan">
                          {{ (list.M7_Msg.wcPayInfo && list.M7_Msg.wcPayInfo.receiverTitle) ? list.M7_Msg.wcPayInfo.receiverTitle : '微信红包' }}
                        </span>
                        <em class="com-p-a com-red-transfer-oem right-red-transfer-oem">
                          {{ (list.M7_Msg.wcPayInfo && list.M7_Msg.wcPayInfo.m7Type === '1') ? '已领取' : '领取红包' }}
                        </em>
                      </div>
                      <!-- 下 -->
                      <p class="com-red-transfer-text right-red-transfer-text">
                        微信红包
                      </p>
                    </div>
                  </div>
                </template>

                <!-- 419430449 转账 -->
                <template v-else-if="list.M7_MsgType === 419430449 && list.M7_Msg.wcPayInfo">
                  <div
                    class="box com-red-content-odv"
                    :class="{'get-bg': (list.M7_Msg.wcPayInfo.m7Type === '1' || list.M7_Msg.wcPayInfo.m7Type === '2' || list.M7_Msg.wcPayInfo.paySubType === '4') }"
                  >
                    <i class="com-icon"></i>
                    <!-- 红包内容 -->
                    <div
                      class="com-red-envelope-odv right-red-envelope-odv"
                      :class="list.status ? 'com-receive-red-envelope-odv' : ''"
                    >
                      <!-- 上 -->
                      <div class="com-red-transfer-odv">
                        <mk-iconfont
                          :icon-class="list.M7_Msg.wcPayInfo.paySubType === '1' ? 'wx-shoukuan' : (list.M7_Msg.wcPayInfo.paySubType === '4' ? 'wx-tuikuan' : 'wx-zhuanzhang')"
                          class="com-p-a com-red-transfer-oi right-red-transfer-oi iconfont"
                          style="color: #fff;"
                        ></mk-iconfont>
                        <span
                          v-if="list.M7_Msg.wcPayInfo.paySubType === '4'"
                          class="com-p-a com-red-transfer-ospan right-red-transfer-ospan"
                        >
                          已退还
                        </span>
                        <span
                          v-else
                          class="com-p-a com-red-transfer-ospan right-red-transfer-ospan"
                        >
                          {{ list.M7_Msg.wcPayInfo.m7Type === '1' ? '已被领取' : (list.M7_Msg.wcPayInfo.m7Type === '2' ? '已收钱' : '转账给你') }}
                        </span>
                        <em class="com-p-a com-red-transfer-oem right-red-transfer-oem">{{ list.M7_Msg.wcPayInfo.feeDesc }}</em>
                      </div>
                      <!-- 下 -->
                      <p class="com-red-transfer-text right-red-transfer-text">
                        微信转账
                      </p>
                    </div>
                  </div>
                </template>

                <!-- 连接 -->
                <template v-else-if="list.M7_MsgType === 49">
                  <div
                    v-if="list.M7_Msg.type === '5' || list.M7_Msg.type === '7'"
                    class="box com-connection-odv"
                  >
                    <!-- 新连接 新界面打开 -->
                    <a
                      v-if="list.M7_Msg.url"
                      class="com-connection-oa"
                      :href="list.M7_Msg.url"
                      target="_blank"
                    >
                      <h4 class="text-ellipsis connect-title">{{ list.M7_Msg.title }}</h4>
                      <p class="com-p-a">{{ list.M7_Msg.des }}</p>
                      <mk-iconfont
                        icon-class="wx-duihuatupian"
                        class="iconfont"
                      ></mk-iconfont>
                    </a>
                    <span
                      v-else
                      class="com-connection-oa"
                    >
                      <h4 class="text-ellipsis connect-title">{{ list.M7_Msg.title }}</h4>
                      <p class="com-p-a">{{ list.M7_Msg.des }}</p>
                      <mk-iconfont
                        icon-class="wx-duihuatupian"
                        class="iconfont"
                      ></mk-iconfont>
                    </span>
                  </div>
                  <div
                    v-if="list.M7_Msg.type === '6'"
                    class="box"
                    @click="chatFileDownload"
                  >
                    <div class="file-box">
                      <div
                        class="file-type text-ellipsis"
                        :class="'file-bg-'+list.M7_Msg.fileType"
                      >
                        {{ list.M7_Msg.fileType || '--' }}
                      </div>
                      <div class="file-name text-ellipsis">
                        {{ list.M7_Msg.title || '--' }}
                      </div>
                      <div class="file-size text-ellipsis">
                        {{ list.M7_Msg.des || '--' }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="list.M7_Msg.type === '33' || list.M7_Msg.type === '36'"
                    class="box app-box"
                  >
                    <div class="app-title">
                      {{ list.M7_Msg.title }}
                    </div>
                    <div class="app-logo">
                      <mk-iconfont
                        icon-class="wx-xiaochengxu"
                        class="iconfont"
                      ></mk-iconfont>小程序
                    </div>
                  </div>
                  <!-- 聊天记录 -->
                  <div
                    v-if="list.M7_Msg.type === '19'"
                    class="box app-box"
                  >
                    <div class="app-title">
                      {{ list.M7_Msg.title }}
                    </div>
                    <div class="app-list box">
                      <p
                        class="app-list-p"
                        v-html="list.M7_Msg.des"
                      ></p>
                    </div>
                    <div class="app-logo">
                      聊天记录
                    </div>
                  </div>
                </template>

                <!-- 名片 -->
                <template v-else-if="list.M7_MsgType === 42 || list.M7_MsgType === 66">
                  <div class="box white-bg com-card-oa">
                    <!-- 上 -->
                    <div class="com-card-up clearfix">
                      <div class="img-box">
                        <img
                          v-if="list.M7_Msg.bigheadimgurl"
                          :src="list.M7_Msg.bigheadimgurl"
                          alt=""
                        >
                        <mk-iconfont
                          v-else
                          icon-class="wx-danren"
                          class="iconfont"
                        ></mk-iconfont>
                      </div>
                      <div class="clearfix card-info-box">
                        <div class="card-nickname">
                          <span class="text-ellipsis">{{ list.M7_Msg.nickname || '--' }}</span>
                          <!-- 男性 #1890FF 女性 #FF6B6B 未知 #D9D9D9 -->
                          <mk-iconfont
                            v-if="list.M7_Msg.sex === '1'"
                            icon-class="wx-user"
                            class="iconfont f1"
                            style="color: #1890ff;"
                          ></mk-iconfont>
                          <mk-iconfont
                            v-else-if="list.M7_Msg.sex === '2'"
                            icon-class="wx-user"
                            class="iconfont fl"
                            style="color: #ff6b6b;"
                          ></mk-iconfont>
                          <mk-iconfont
                            v-else
                            icon-class="wx-user"
                            class="iconfont fl"
                            style="color: #d9d9d9;"
                          ></mk-iconfont>
                        </div>
                        <div class="card-alias">
                          微信号：{{ list.M7_Msg.alias || '--' }}
                        </div>
                        <div class="card-addr">
                          地区： {{ list.M7_Msg.province }} {{ list.M7_Msg.city }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 文件 -->
                <template v-else-if="list.M7_MsgType === 'file'">
                  <div class="box com-file-odv">
                    <!-- 左右浮动 -->
                    <div class="com-file-box clearfix">
                      <img
                        :src="list.headImg"
                        alt=""
                        class="fl com-ow-36"
                      >
                      <div class="fl file-up-down">
                        <p class="">
                          座席导出文件表格座席导出文件表格.doc
                        </p>
                        <span>23kb</span>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 表情 -->
                <template v-else-if="list.M7_MsgType === 47">
                  <div class="box">
                    <div class="emoj-box">
                      <mk-iconfont
                        icon-class="wx-biaoqingqueshengtu"
                        class="iconfont"
                      ></mk-iconfont>
                      <p class="img-none-tip">
                        暂时无法显示表情
                      </p>
                    </div>
                  </div>
                </template>

                <!-- 位置 -->
                <template v-else-if="list.M7_MsgType === 48">
                  <div class="box">
                    <div class="addr-box">
                      <p class="t1 text-over">
                        {{ list.M7_Msg.poiname || '--' }}
                      </p>
                      <p class="t2 text-over">
                        {{ list.M7_Msg.label || '--' }}
                      </p>
                      <div class="img-box">
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 语音或视频 -->
                <template v-else-if="list.M7_MsgType === 50">
                  <div class="box">
                    <div
                      v-if="list.M7_Msg.indexOf('video') > -1"
                      class="call-video-box"
                    >
                      <mk-iconfont
                        icon-class="wx-duihuashipin"
                        class="iconfont"
                      ></mk-iconfont> 视频聊天
                    </div>
                    <div
                      v-else
                      class="call-video-box"
                    >
                      <mk-iconfont
                        icon-class="wx-duihuatonghua"
                        class="iconfont"
                      ></mk-iconfont>
                      语音聊天
                    </div>
                  </div>
                </template>

                <!-- 位置分享 -->
                <template v-else-if="list.M7_MsgType === -1879048186">
                  <div class="box">
                    <mk-iconfont
                      icon-class="wx-duihuaweizhi"
                      class="iconfont"
                    >
                    </mk-iconfont>
                    &nbsp;{{ list.M7_Msg }}
                  </div>
                </template>

                <!-- 其他类型 -->
                <template v-else>
                  <div class="box">
                    <span>【{{ list.M7_Msg }}】</span>
                  </div>
                </template>

                <!-- 已删除 -->
                <template v-if="list.M7_MsgStatus && list.M7_MsgStatus !== 'normal'">
                  <mk-tooltip
                    class="item"
                    effect="dark"
                    :content=" list.M7_MsgStatus === 'deleted' ? '此消息已被删除' : '此消息已被撤回'"
                    placement="top"
                  >
                    <i class="com-del-msg-oi right-del-msg-oi com-p-a el-icon-info"></i>
                  </mk-tooltip>
                </template>
              </div>
            </div>
            <p
              v-if="list.IsSend === '1'"
              class="com-agent-info"
            >
              座席：{{ wxUser.Uname }}
            </p>
          </li>
        </template>
      </ul>
    </div>
    <!-- 默认图片 -->
    <div
      v-else
      class="no-content"
    >
      <img
        src="@assets/images/chatDefaultImg.png"
        alt="暂无数据"
      >
    </div>
    <!-- 视频播放 -->
    <video-player
      :visible.sync="mediaObj.show"
      :url="mediaObj.url"
    ></video-player>
    <audio-player
      :audio-url.sync="audioUrl"
      :tar-url.sync="tarUrl"
    ></audio-player>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import VideoPlayer from './components/video-player'
import AudioPlayer from './components/audio-player'
export default {
  name: 'WechatRecord',
  components: {
    VideoPlayer,
    AudioPlayer
  },
  props: {
    chatData: {
      type: Object,
      default: () => {
        return {
          count: 0,
          message: [],
          wxContact: {},
          wxUser: {}
        }
      }
    },
    // 剩余可加载条数
    overTotal: {
      type: Number,
      default: 0
    },
    // 是否为搜索
    isSearch: {
      type: Boolean,
      default: false
    },
    // 当前页数
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dialogVisible: false,
      friObj: {}, // 好友默认空值
      wechatObj: {}, // 微信默认空值
      uidsObj: [], // 该微信下所有座席列表
      soundStatus: false,
      changeHightNum: 0, // 默认0
      selectAgent: '', // 重复好友座席默认选中第一个
      selectContact: '', // 重复好友默认选中第一个
      soundObj: {
        soundUrl: '',
        _id: ''
      },
      dateValue: [],
      msgContent: '',
      pageSize: 20,
      chatDetailList: [], // 聊天内容列表
      // 视频数据
      mediaObj: {
        show: false,
        url: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // 好友相关信息
      wxContact: {},
      // 当前用户相关信息
      wxUser: {},
      // 录音的url + uuid
      audioUrl: '',
      // 录音的url
      tarUrl: ''
    }
  },
  watch: {
    chatData: {
      handler () {
        this.initChat()
      },
      deep: true
    }
  },
  mounted () {
    this.initChat()
  },
  methods: {
    // 播放语音
    playAudio (url) {
      if (!url) {
        this.$message.error('语音播放地址不存在')
      }
      this.audioUrl = url + '?selfRandom=' + this.uuid()
      this.tarUrl = url
    },
    // 加载更多
    loadMoreMsg () {
      this.$emit('loadMore')
    },
    initChat () {
      let data = this._.cloneDeep(this.chatData)
      // 搜索的时候清空列表
      if (this.isSearch) {
        this.chatDetailList = []
      }
      this.wxUser = data.wxUser || {} // 微信相关信息
      this.wxContact = data.wxContact || {} // 好友相关信息
      let wxMessage = data.message || []
      wxMessage = wxMessage.reverse() // 反转下
      for (let list of wxMessage) {
        // 时间处理
        if (list.M7_Ts) {
          list.M7_Ts = dayjs(list.M7_Ts * 1000).format('YYYY-MM-DD HH:mm:ss')
        }
        // 系统数据处理 M7_MsgType === 10000 红包、转账处理 419430449
        if (
          list.M7_MsgType &&
          (list.M7_MsgType === 10000 ||
            list.M7_MsgType === 10002 ||
            list.M7_MsgType === 419430449 ||
            list.M7_MsgType === 436207665 ||
            list.M7_MsgType === 49)
        ) {
          let str = this._.cloneDeep(list.M7_Msg)
          if (str) {
            try {
              list.M7_Msg = JSON.parse(str)
              if (
                list.M7_Msg.content &&
                list.M7_Msg.content.indexOf('_wc_custom_link_') > -1
              ) {
                // 添加 target跳转方式
                list.M7_Msg.content = list.M7_Msg.content.replace(
                  '_wc_custom_link_',
                  'a target="_blank"'
                )
                list.M7_Msg.content.replace(/_wc_custom_link_/g, 'a')
              }
            } catch (err) {
              list.M7_Msg = ''
            }
          }
        }
        //  位置处理
        if (list.M7_MsgType && list.M7_MsgType === 48) {
          let str = this._.cloneDeep(list.M7_Msg)
          list.M7_Msg = {
            label: this.$attrSub('label=', str),
            poiname: this.$attrSub('poiname=', str),
            status: 0
          }
        }
        // 实时位置
        if (list.M7_MsgType && list.M7_MsgType === -1879048186) {
          let str = this._.cloneDeep(list.M7_Msg)
          list.M7_Msg = subStr('title><![CDATA[', ']]></title', str)
        }
        // 名片
        if (
          list.M7_MsgType &&
          (list.M7_MsgType === 42 || list.M7_MsgType === 66)
        ) {
          let str = this._.cloneDeep(list.M7_Msg)
          if (str.indexOf('xml version="1.0"?>') > -1) {
            str = subStr('xml version="1.0"?>', '/>', str)
          }
          list.M7_Msg = {
            smallheadimgurl: this.attrSub(' smallheadimgurl=', str),
            bigheadimgurl: this.attrSub(' bigheadimgurl=', str),
            province: this.attrSub(' province=', str),
            city: this.attrSub(' city=', str),
            sex: this.attrSub(' sex=', str),
            alias: this.attrSub(' alias=', str),
            nickname: this.attrSub(' nickname=', str)
          }
        }
        this.chatDetailList.unshift(list)
      }
      this.$nextTick(() => {
        // odv.scrollTop 赋值为ul的高度【总高度 - 加载更多的所占的高度 - 外容器border】
        let odv = this.$refs.friendChatDetail
        let oul = this.$refs.chatDetailOul
        if (this.page === 1) this.changeHightNum = 0 // 初次展示
        if (odv) {
          // 避免chatDetailList为空时获取不到报错
          let num = parseInt(oul.offsetHeight) - parseInt(this.changeHightNum)
          odv.scrollTop = num
          this.changeHightNum = oul.offsetHeight
        }
      })
    },
    attrSub (attr, str) {
      // 使用方法 ('test=', '< test="123" src="456"></test>') 输出123
      var t = attr + '""'
      if (str.indexOf(t) > -1) {
        return ''
      }
      var reg = new RegExp(`\\${attr}"(.+?)\\"`, 'g')
      var arr = str.match(reg)
      var text = ''
      if (arr && arr.length > 0) {
        text = arr[0].replace(attr, '').replace(/"/g, '')
      }
      return text || ''
    },
    handleScroll (ev) {
      if (!ev.target.scrollTop) {
        if (this.overTotal > 0) {
          this.loadMoreMsg()
        }
      }
    },
    // 下载聊天记录
    downloadChat () {
      let data = {}
      // 如果selectAgent有值 && friendDetailObj.repeatContacts存在,则取selectAgent的值，否则正常取值this.friendDetailObj.M7Agent
      if (
        this.friendDetailObj.repeatContacts &&
        this.selectAgent &&
        this.selectContact
      ) {
        data.contactId = this.selectContact
        data.agent = this.selectAgent
      } else {
        // 除了重复好友查看聊天详情内容
        data.contactId = this.friendDetailObj.M7Id
        data.agent = this.friendDetailObj.M7Agent
      }
      if (this.msgContent) {
        data.msgContent = this.msgContent
      }
      if (this.dateValue) {
        let notifyTime = this.dateValue
        if (notifyTime[0]) {
          data.begin = dayjs(notifyTime[0]).format('YYYY-MM-DD')
        }
        if (notifyTime[1]) {
          data.end = dayjs(notifyTime[1]).format('YYYY-MM-DD')
        }
      }
      this.$http.exportWxMessage(data).then(res => {
        if (res.code) {
          this.$downloadFile({ name: res.data })
        }
      })
    },
    // 播放视频
    showVideoPlay (url) {
      if (url) {
        url = 'https://' + url
        let data = {
          show: true,
          url
        }
        this.mediaObj = data
      } else {
        this.$message.error('设备端未下载此视频，无法查看详情')
      }
    },
    // 不支持下载文件
    chatFileDownload () {
      this.$message.info('当前暂不支持下载聊天文件')
    }
  }
}
</script>

<style lang="scss" scoped>
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
  border: 0;
  font-weight: normal;
  vertical-align: baseline;
  box-sizing: border-box;
}

em {
  font-style: normal;
}

/* 左浮动 */
.fl {
  float: left;
}

/* 右浮动 */
.fr {
  float: right;
}

// 聊天记录样式
.wechat-record {
  height: 100%;

  .box {
    position: relative;
    min-height: 14px;
    overflow: visible;
  }

  .box > span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    line-height: 18px;
    color: #262626;
    font-size: 12px;
  }

  .box > video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .com-p-a {
    position: absolute;
  }

  .white-bg {
    background: #fff !important;
  }

  .com-ow-36 {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
  }

  .chat-left {
    float: left;
  }

  .chat-right {
    float: right;
  }

  .chat-left .com-ow-36 {
    float: left;
  }

  .chat-right .com-ow-36 {
    float: right;
  }

  .com-date {
    margin-bottom: 6px;
    color: #b8b8b8;
    font-size: 12px;
  }

  .chat-detail-wrap,
  .group-chat-detail {
    width: 100%;
    height: calc(100% - 32px);
    padding: 8px 0;
    overflow-y: auto;
    box-sizing: border-box;
    // background: #f0f1f2;

    .chat-load-msg {
      text-align: center;
      margin: 10px 0 30px;

      .loading-more-btn {
        display: inline-block;
        width: 210px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        color: #009cff;
        cursor: pointer;
        border-radius: 10px;
        background: #e8e8e8;
      }
    }
  } /* li */
  .com-chat-detail {
    width: 90%;
    margin: 10px 0;
    position: relative;

    .com-del-msg-oi {
      top: 12px;
      cursor: pointer;
      color: #ff6b6b;
      font-size: 14px;
    }
  }

  .chat-detail-system {
    width: 100% !important;
    text-align: center;

    p {
      display: inline-block;
      min-width: 210px;
      min-height: 26px;
      padding: 6px 20px;
      font-size: 12px;
      line-height: 18px;
      background: #e8e8e8;
      color: #999;
      border-radius: 20px;
    }
  }

  .sensitive-system {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .chat-left .com-del-msg-oi {
    right: -22px;
  }

  .chat-right .com-del-msg-oi {
    left: -22px;
  }

  .left-date {
    margin-left: 42px;
  }

  .com-agent-info {
    color: #595959;
    font-size: 12px;
    margin-top: 6px;
  }

  .chat-left .com-date,
  .chat-left .com-agent-info {
    margin-left: 42px;
  }

  .chat-right .com-date,
  .chat-right .com-agent-info {
    margin-right: 42px;
    text-align: right;
  }

  .left-agent-info {
    margin-left: 42px;
  }

  .com-content-odv {
    position: relative;
    max-width: 80%;
    padding: 9px 10px;
    border-radius: 6px;
    background: #fff;
    min-height: 36px;
    box-sizing: border-box;

    /* ��ͷͷ�� */
    .com-icon::after {
      position: absolute;
      top: 11px;
      content: '';
    }

    > span {
      display: inline-block;
      width: 100%;
      word-wrap: break-word;
      line-height: 18px;
      color: #262626;
      font-size: 12px;
    }
  }

  .com-content-odv.type-1 {
    border: 1px solid #d9d9d9;
  }

  .chat-left .com-content-odv.type-1::after {
    content: '';
    position: absolute;
    top: 10px;
    left: -7px;
    border-width: 7px 7px 7px 0;
    border-color: transparent #d9d9d9 transparent transparent;
    border-style: solid;
    z-index: 98;
  }

  .chat-right .com-content-odv.type1::after {
    content: '';
    position: absolute;
    top: 10px;
    right: -7px;
    border-width: 7px 0 7px 7px;
    border-color: transparent transparent transparent #d9d9d9;
    border-style: solid;
    z-index: 98;
  }

  .chat-left .com-icon::after {
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-color: transparent #fff transparent transparent;
    border-style: solid;
    z-index: 99;
  }

  .chat-right .com-icon::after {
    right: -6px;
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent #b0e36e;
    border-style: solid;
    z-index: 99;
  }

  .chat-left .com-red-content-odv .com-icon::after {
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-color: transparent #fa9d3b transparent transparent;
    border-style: solid;
  }

  .chat-right .com-red-content-odv .com-icon::after {
    // lright: -6px;
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent #fa9d3b;
    border-style: solid;
  }

  .chat-left .receive-box .com-icon::after {
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-color: transparent #07b464 transparent transparent;
    border-style: solid;
  }

  .chat-right .receive-box .com-icon::after {
    // lright: -6px;
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent #07b464;
    border-style: solid;
  }

  .chat-right .get-bg .com-icon::after {
    // lright: -6px;
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent #ffbf7c;
    border-style: solid;
  }

  .chat-left .get-bg .com-icon::after {
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-color: transparent #ffbf7c transparent transparent;
    border-style: solid;
  }

  .com-red-content-odv {
    padding: 0;

    .com-red-envelope-odv {
      width: 188px;
      height: 76px;
      font-size: 12px;
    }

    .com-receive-red-envelope-odv,
    .com-receive-red-icon::after {
      opacity: 0.6;
    }

    .com-red-transfer-odv {
      position: relative;
      height: 52px;
      color: #fff;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      background: #fa9d3b;

      .com-red-transfer-oi {
        left: 8px;
        top: 10px;
        font-size: 32px;
        color: #f5222d;
      }

      .right-red-transfer-oi {
        right: 8px;
      }

      .com-red-transfer-ospan,
      .com-red-transfer-oem {
        top: 13px;
        left: 44px;
        max-width: 144px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .com-red-transfer-ospan {
        font-size: 13px;
        font-weight: 500;
      }

      .com-red-transfer-oem {
        top: 30px;
      }
    }
  }

  .chat-right .get-bg .com-red-transfer-odv {
    background: #ffbf7c !important;
  }

  .com-chat-detail .com-main-box .com-red-transfer-odv {
    .iconshoukuan,
    .iconzhuanzhang1 {
      color: #fff;
    }
  }

  .com-red-oi {
    left: 8px;
    top: 10px;
    background: url('~@assets/images/redIcon1.png') center center no-repeat;
    background-size: 23px 28px;
    width: 32px;
    height: 32px;
  }

  .get-bg .com-red-oi {
    background: url('~@assets/images/redIcon0.png') center center no-repeat;
    background-size: 23px 28px;
  }

  .com-red-transfer-text {
    height: 24px;
    line-height: 24px;
    color: #595959;
    margin-left: 14px;
  }

  .right-red-transfer-text {
    margin-right: 14px;
  }

  .left-red-content-odv {
    margin-left: 10px;
  }

  .right-red-content-odv {
    margin-right: 10px;
  }

  .chat-left .com-content-odv {
    margin-left: 10px;
    float: left;
  }

  .chat-right .com-content-odv {
    margin-right: 10px;
    background: #b0e36e;
    float: right;
  }

  .com-voice-odv {
    width: 160px;
    cursor: pointer;
    height: 16px;

    .com-voice-text {
      top: 0;
      font-style: normal;
    }

    .left-voice-text {
      right: 2px;
    }

    .right-voice-text {
      left: 2px;
    }
  }

  .chat-left .com-voice-oi {
    top: 2px;
    right: 2px;
  }

  .chat-right .com-voice-oi {
    top: 2px;
    left: 2px;
  }

  .com-connection-odv {
    width: 260px;
    height: 78px;
    margin-left: 4px;

    .com-connection-oa {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      color: #595959;

      > h4 {
        width: 172px;
        font-size: 14px;
        margin-bottom: 10px;
        line-height: 20px;
      }

      > p {
        font-size: 12px;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 172px;
        height: 34px;
      }

      > i {
        right: 8px;
        top: 8px;
        width: 44px;
        height: 44px;
        line-height: 44px;
        display: block;
        position: absolute;
        font-size: 52px;
        color: #d1d1d1;
      }
    }
  }

  .right-connection-odv {
    margin-right: 10px;
  }

  .emoj-box {
    width: 120px;
    height: 120px;
    line-height: 100px;
    background: #fff;
    color: #b8b8b8;
    text-align: center;
    cursor: pointer;

    .iconfont {
      font-size: 60px;
      color: #d1d1d1;
    }

    .img-none-tip {
      position: absolute;
      left: 0;
      bottom: 0;
      line-height: 16px;
      height: 40px;
      padding: 0 8px;
      font-size: 12px;
      text-align: center;
      width: 100%;
    }
  }

  .view-img-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
      height: 100%;
      width: auto;
      margin: 0 auto;
    }
  }

  .com-img-odv,
  .com-video-odv {
    width: 134px;
    height: 122px;
    padding: 0;
    cursor: pointer;
    background: #fff;

    img,
    video {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  .com-card-oa {
    width: 230px;
    overflow: hidden;
    height: 66px;
    padding: 8px;
    border-radius: 6px;

    .img-box {
      width: 46px;
      height: 46px;
      text-align: center;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      overflow: hidden;

      > img {
        width: 100%;
        height: 100%;
      }

      .iconfont {
        line-height: 46px;
        font-size: 34px;
        text-align: center;
        color: #d1d1d1;
      }
    }

    .card-info-box {
      margin-left: 10px;
      width: 160px;
      height: 100%;
      position: absolute;
      left: 56px;
      top: 0;
      padding: 6px 0;

      .card-nickname {
        white-space: nowrap;
        display: block;
        width: 160px;
        line-height: 20px;
        overflow: hidden;
        font-weight: 500;

        > span {
          max-width: 130px;
          font-weight: 500;
          margin-right: 2px;
          float: left;
        }
      }

      .card-alias,
      .card-addr {
        line-height: 18px;
        font-size: 12px;
      }
    }
  }

  .right-card-oa {
    margin-right: 10px;
  }

  .com-file-odv {
    width: 240px;

    .com-file-box {
      img {
        width: 44px;
        height: 44px;
      }

      .file-up-down {
        margin-left: 8px;
        width: 160px;

        p {
          font-size: 14px;
          color: #595959;
          line-height: 18px;
          margin-bottom: 10px;
        }

        span {
          font-size: 12px;
        }
      }
    }
  }

  .right-file-odv {
    margin-right: 10px;
  }

  .com-video-odv {
    .com-video-oicon {
      position: absolute;
      top: 42px;
      left: 50px;
      padding: 6px;
      border-radius: 50%;
      font-size: 20px;
      background: #000;
      opacity: 0.6;
      color: #fff;
    }
  }

  .right-video-odv,
  .right-img-odv {
    margin-right: 10px;
  }

  .no-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 513px;
  }

  .addr-box {
    width: 230px;
    padding-top: 8px;

    .t1 {
      padding-left: 12px;
      width: 100%;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      margin-top: 2px;
    }

    .t2 {
      padding-left: 12px;
      width: 100%;
      font-size: 12px;
      line-height: 16px;
      color: #b8b8b8;
      margin-top: 5px;
    }

    .img-box {
      height: 100px;
      width: 100%;
      margin-top: 5px;
    }
  }

  .chat-right .type-42,
  .chat-right .type-66,
  .chat-right .type-48,
  .chat-right .type-47,
  .chat-right .type-43,
  .chat-right .type-3 {
    padding: 0;
    background: #fff;

    .com-icon::after {
      right: -6px;
      border-width: 6px 0 6px 6px;
      border-color: transparent transparent transparent #fff;
      border-style: solid;
    }
  }

  .chat-left .type-42,
  .chat-left .type-66,
  .chat-left .type-48,
  .chat-left .type-47,
  .chat-left .type-43,
  .chat-left .type-3 {
    padding: 0;
    background: #fff;

    .com-icon::after {
      left: -6px;
      border-width: 6px 6px 6px 0;
      border-color: transparent #fff transparent transparent;
      border-style: solid;
    }
  }

  .com-chat-detail .type-419430449,
  .com-chat-detail .type-436207665,
  .com-chat-detail .type-43620766501 {
    padding: 0;
    background: #fff;
  }

  .com-chat-detail .type-49 {
    background: #fff;
    padding: 0;
  }

  .chat-right .type-49 .com-icon::after {
    right: -6px;
    border-width: 6px 0 6px 6px;
    border-color: transparent transparent transparent #fff;
    border-style: solid;
  }

  .type-49 .com-connection-odv {
    padding: 8px;
  }

  .type-43 .emoj-box {
    line-height: 120px;
  }

  .file-box {
    width: 208px;
    padding: 12px;
    position: relative;

    .file-type {
      width: 44px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      background: #ff6b6b;
      text-align: center;
      border-radius: 4px;
    }

    .file-bg-txt,
    .file-bg-word {
      background: #4d81e6;
    }

    .file-bg-ppt {
      background: #f57b25;
    }

    .file-bg-xlsx,
    .file-bg-xls {
      background: #70a839;
    }

    .file-name {
      line-height: 20px;
      height: 20px;
      width: 118px;
      font-size: 14px;
      color: #595959;
      position: absolute;
      right: 12px;
      top: 12px;
    }

    .file-size {
      line-height: 20px;
      height: 20px;
      width: 118px;
      font-size: 14px;
      color: #595959;
      position: absolute;
      right: 12px;
      bottom: 12px;
    }
  }

  .app-box {
    width: 220px;
    overflow: hidden;
    padding: 10px;
    padding-bottom: 6px;
    color: #595959;

    .app-title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 20px;
      font-size: 14px;
    }

    .app-logo {
      padding-top: 6px;
      border-top: 1px solid #e8e8e8;
      margin-top: 10px;
      font-size: 12px;
      line-height: 14px;

      .iconfont {
        display: block;
        float: left;
        margin-right: 4px;
        color: #000;
      }
    }

    .app-list {
      margin-top: 8px;
      color: #b8b8b8;
      font-size: 12px;

      .app-list-p {
        line-height: 16px;
      }
    }
  }

  .audio-icon {
    width: 16px;
    height: 16px;
  }

  .audio-an-left {
    animation: audioAnLeft 1.2s infinite;
  }

  .audio-an-right {
    animation: audioAnRight 1.2s infinite;
  }

  .audio-icon-left {
    background:
      url('~@assets/images/voice-right-03.png') no-repeat center
      center;
    background-size: 100% 100%;
    float: right;
  }

  .audio-icon-right {
    background: url('~@assets/images/voice-left-03.png') no-repeat center center;
    background-size: 100% 100%;
  }

  @keyframes audioAnLeft {
    0% {
      background:
        url('~@assets/images/voice-left-01.png') no-repeat center
        center;
      background-size: 100% 100%;
    }

    50% {
      background:
        url('~@assets/images/voice-left-02.png') no-repeat center
        center;
      background-size: 100% 100%;
    }

    100% {
      background:
        url('~@assets/images/voice-left-03.png') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }

  @keyframes audioAnRight {
    0% {
      background:
        url('~@assets/images/voice-right-01.png') no-repeat center
        center;
      background-size: 100% 100%;
    }

    50% {
      background:
        url('~@assets/images/voice-right-02.png') no-repeat center
        center;
      background-size: 100% 100%;
    }

    100% {
      background:
        url('~@assets/images/voice-right-03.png') no-repeat center
        center;
      background-size: 100% 100%;
    }
  }

  .receive-box {
    width: 180px;
    background: #07b464;
    color: #fff;
    border-radius: 6px;

    .iconhuodongzhangdan {
      position: absolute;
      left: 10px;
      top: 15px;
      font-size: 26px;
    }

    .receive-t-box {
      width: 138px;
      padding-left: 42px;
      padding-top: 6px;
      padding-bottom: 8px;

      .r-t {
        font-size: 14px;
        line-height: 16px;
        margin-top: 4px;
      }

      .receive-t1 {
        height: 24px;
        border-bottom: 1px dashed #fff;
      }

      .receive-t2 {
        margin-top: 6px;
        font-size: 12px;
      }
    }

    .receive-b-tip {
      height: 24px;
      line-height: 24px;
      color: #595959;
      font-size: 12px;
      background: #fff;
      padding-left: 12px;
    }
  }

  .text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
